// Mock data for the website
export const recipes = [
    {
      id: 1,
      title: "Movie Night",
      description: "",
      image: "/images/gallery/MovieNight/3.JPG",
      category: "pasta",
      prepTime: 15,
      cookTime: 25,
      servings: 4,
      difficulty: "Medium",
      ingredients: [
     
      ],
      instructions: [
   
      ],
      featured: true,
      popular: true,
      galleryImages: [
        "/images/gallery/MovieNight/1.JPG",
        "/images/gallery/MovieNight/2.JPG",
        "/images/gallery/MovieNight/3.JPG"
      ]
    },
    {
      id: 2,
      title: "Summer Menu",
      description: "Juicy homemade beef burger with all the favorite toppings.",
      image: "/images/gallery/SummerMenu/1.JPG",
      category: "Summer",
      prepTime: 20,
      cookTime: 15,
      servings: 4,
      difficulty: "Easy",
      ingredients: [
        "1.5 lbs ground beef (80/20)",
        "1 tsp Worcestershire sauce",
        "1 tsp garlic powder",
        "1 tsp onion powder",
        "Salt and pepper to taste",
        "4 burger buns",
        "4 slices cheddar cheese",
        "Lettuce leaves",
        "Tomato slices",
        "Red onion slices",
        "Dill pickle slices",
        "Ketchup and mustard"
      ],
      instructions: [
        "In a large bowl, mix ground beef with Worcestershire sauce, garlic powder, onion powder, salt, and pepper.",
        "Divide the mixture into 4 equal portions and form into patties about 1/2 inch thick. Press a slight indentation in the center of each patty with your thumb.",
        "Preheat grill or skillet to medium-high heat.",
        "Cook burgers for about 4-5 minutes on each side for medium doneness.",
        "Add cheese slices on top during the last minute of cooking and cover to melt.",
        "Toast the burger buns lightly if desired.",
        "Assemble the burgers with lettuce, tomato, onion, pickles, and condiments."
      ],
      featured: true,
      popular: true,
      galleryImages: [
        "/images/gallery/SummerMenu/1.JPG",
        "/images/gallery/SummerMenu/2.JPG",
        "/images/gallery/SummerMenu/3.JPG",
        "/images/gallery/SummerMenu/4.JPG",
        "/images/gallery/SummerMenu/5.JPG",
        "/images/gallery/SummerMenu/6.JPG"
      ]
    },
    {
      id: 3,
      title: "Table Concepts",
      description: "A quick and healthy vegetable stir fry with a delicious sauce.",
      image: "/images/gallery/TableConcepts/1.JPG",
      category: "table",
      prepTime: 15,
      cookTime: 10,
      servings: 4,
      difficulty: "Easy",
      ingredients: [
        "2 tbsp vegetable oil",
        "2 cloves garlic, minced",
        "1 tbsp ginger, minced",
        "1 bell pepper, sliced",
        "1 carrot, julienned",
        "1 cup broccoli florets",
        "1 cup snap peas",
        "1 cup mushrooms, sliced",
        "1/4 cup soy sauce",
        "1 tbsp honey",
        "1 tsp sesame oil",
        "1 tbsp cornstarch mixed with 2 tbsp water",
        "Sesame seeds for garnish",
        "Green onions, chopped for garnish"
      ],
      instructions: [
        "Heat vegetable oil in a large wok or skillet over high heat.",
        "Add garlic and ginger, stir for 30 seconds until fragrant.",
        "Add all vegetables and stir fry for 5-6 minutes until crisp-tender.",
        "In a small bowl, whisk together soy sauce, honey, and sesame oil.",
        "Pour sauce over vegetables and stir to coat.",
        "Add cornstarch slurry and cook for an additional minute until sauce thickens.",
        "Garnish with sesame seeds and green onions.",
        "Serve over rice or noodles if desired."
      ],
      featured: true,
      popular: true,
      galleryImages: [
        "/images/gallery/MovieNight/1.JPG",
        "/images/gallery/MovieNight/2.JPG",
        "/images/gallery/MovieNight/3.JPG"
      ]
    },
    {
      id: 4,
      title: "Spring Menu",
      description: "Soft and chewy chocolate chip cookies that are perfect for any occasion.",
      image: "/images/gallery/Spring/1.JPG",
      category: "spring",
      prepTime: 15,
      cookTime: 12,
      servings: 24,
      difficulty: "Easy",
      ingredients: [
        "1 cup unsalted butter, softened",
        "3/4 cup granulated sugar",
        "3/4 cup packed brown sugar",
        "2 large eggs",
        "2 tsp vanilla extract",
        "2 1/4 cups all-purpose flour",
        "1 tsp baking soda",
        "1/2 tsp salt",
        "2 cups semi-sweet chocolate chips"
      ],
      instructions: [
        "Preheat oven to 375°F (190°C). Line baking sheets with parchment paper.",
        "In a large bowl, cream together butter and both sugars until light and fluffy.",
        "Beat in eggs one at a time, then stir in vanilla.",
        "In a separate bowl, combine flour, baking soda, and salt.",
        "Gradually blend the dry ingredients into the wet mixture.",
        "Fold in chocolate chips.",
        "Drop by rounded tablespoons onto the prepared baking sheets, about 2 inches apart.",
        "Bake for 9-11 minutes or until golden brown around the edges.",
        "Allow cookies to cool on the baking sheet for 5 minutes before transferring to a wire rack."
      ],
      featured: true,
      popular: false
    },
    {
      id: 5,
      title: "Food Concepts",
      description: "A refreshing and healthy traditional Greek salad with feta cheese and olives.",
      image: "/images/gallery/FoodConcepts/1.JPG",
      category: "food",
      prepTime: 15,
      cookTime: 0,
      servings: 4,
      difficulty: "Easy",
      foodRecipes : [
          {
            id: 1,
            title: "Movie Night",
            description: "A delicious Italian-inspired dish with creamy garlic sauce and sun-dried tomatoes.",
            image: "/images/gallery/MovieNight/3.JPG",
            category: "pasta",
            prepTime: 15,
            cookTime: 25,
            servings: 4,
            difficulty: "Medium",
            ingredients: [
              "2 large chicken breasts, cut into strips",
              "8 oz fettuccine pasta",
              "3 cloves garlic, minced",
              "1 cup heavy cream",
              "1/2 cup chicken broth",
              "1/2 cup grated parmesan cheese",
              "1/2 cup sun-dried tomatoes, chopped",
              "2 cups fresh spinach",
              "1 tsp dried Italian herbs",
              "Salt and pepper to taste",
              "2 tbsp olive oil",
              "Fresh basil for garnish"
            ],
            instructions: [
              "Boil the pasta according to package instructions until al dente. Drain and set aside.",
              "Season chicken strips with salt, pepper, and Italian herbs.",
              "Heat olive oil in a large skillet over medium-high heat. Add chicken and cook until golden and cooked through, about 5-6 minutes. Remove and set aside.",
              "In the same skillet, add minced garlic and cook for 30 seconds until fragrant.",
              "Add the chicken broth and scrape up any browned bits from the bottom of the pan.",
              "Pour in the heavy cream and bring to a simmer. Stir in the parmesan cheese until melted.",
              "Add the sun-dried tomatoes and spinach, stirring until the spinach wilts.",
              "Return the chicken to the skillet and add the cooked pasta. Toss everything together until well coated.",
              "Garnish with fresh basil and additional parmesan cheese if desired."
            ],
            featured: true,
            popular: true,
            galleryImages: [
              "/images/gallery/MovieNight/1.JPG",
              "/images/gallery/MovieNight/2.JPG",
              "/images/gallery/MovieNight/3.JPG"
            ]
          },
          {
            id: 2,
            title: "Summer Menu",
            description: "Juicy homemade beef burger with all the favorite toppings.",
            image: "/images/gallery/SummerMenu/1.JPG",
            category: "Summer",
            prepTime: 20,
            cookTime: 15,
            servings: 4,
            difficulty: "Easy",
            ingredients: [
              "1.5 lbs ground beef (80/20)",
              "1 tsp Worcestershire sauce",
              "1 tsp garlic powder",
              "1 tsp onion powder",
              "Salt and pepper to taste",
              "4 burger buns",
              "4 slices cheddar cheese",
              "Lettuce leaves",
              "Tomato slices",
              "Red onion slices",
              "Dill pickle slices",
              "Ketchup and mustard"
            ],
            instructions: [
              "In a large bowl, mix ground beef with Worcestershire sauce, garlic powder, onion powder, salt, and pepper.",
              "Divide the mixture into 4 equal portions and form into patties about 1/2 inch thick. Press a slight indentation in the center of each patty with your thumb.",
              "Preheat grill or skillet to medium-high heat.",
              "Cook burgers for about 4-5 minutes on each side for medium doneness.",
              "Add cheese slices on top during the last minute of cooking and cover to melt.",
              "Toast the burger buns lightly if desired.",
              "Assemble the burgers with lettuce, tomato, onion, pickles, and condiments."
            ],
            featured: true,
            popular: true,
            galleryImages: [
              "/images/gallery/SummerMenu/1.JPG",
              "/images/gallery/SummerMenu/2.JPG",
              "/images/gallery/SummerMenu/3.JPG",
              "/images/gallery/SummerMenu/4.JPG",
              "/images/gallery/SummerMenu/5.JPG",
              "/images/gallery/SummerMenu/6.JPG"
            ]
          },
          {
            id: 3,
            title: "Table Concepts",
            description: "A quick and healthy vegetable stir fry with a delicious sauce.",
            image: "/images/gallery/FoodConcepts/1.JPG",
            category: "table",
            prepTime: 15,
            cookTime: 10,
            servings: 4,
            difficulty: "Easy",
            ingredients: [
              "2 tbsp vegetable oil",
              "2 cloves garlic, minced",
              "1 tbsp ginger, minced",
              "1 bell pepper, sliced",
              "1 carrot, julienned",
              "1 cup broccoli florets",
              "1 cup snap peas",
              "1 cup mushrooms, sliced",
              "1/4 cup soy sauce",
              "1 tbsp honey",
              "1 tsp sesame oil",
              "1 tbsp cornstarch mixed with 2 tbsp water",
              "Sesame seeds for garnish",
              "Green onions, chopped for garnish"
            ],
            instructions: [
              "Heat vegetable oil in a large wok or skillet over high heat.",
              "Add garlic and ginger, stir for 30 seconds until fragrant.",
              "Add all vegetables and stir fry for 5-6 minutes until crisp-tender.",
              "In a small bowl, whisk together soy sauce, honey, and sesame oil.",
              "Pour sauce over vegetables and stir to coat.",
              "Add cornstarch slurry and cook for an additional minute until sauce thickens.",
              "Garnish with sesame seeds and green onions.",
              "Serve over rice or noodles if desired."
            ],
            featured: true,
            popular: true,
            galleryImages: [
              "/images/gallery/MovieNight/1.JPG",
              "/images/gallery/MovieNight/2.JPG",
              "/images/gallery/MovieNight/3.JPG"
            ]
          },
          {
            id: 4,
            title: "/images/gallery/Spring/1.JPG",
            description: "Soft and chewy chocolate chip cookies that are perfect for any occasion.",
            image: "/images/402.png",
            category: "desserts",
            prepTime: 15,
            cookTime: 12,
            servings: 24,
            difficulty: "Easy",
            ingredients: [
              "1 cup unsalted butter, softened",
              "3/4 cup granulated sugar",
              "3/4 cup packed brown sugar",
              "2 large eggs",
              "2 tsp vanilla extract",
              "2 1/4 cups all-purpose flour",
              "1 tsp baking soda",
              "1/2 tsp salt",
              "2 cups semi-sweet chocolate chips"
            ],
            instructions: [
              "Preheat oven to 375°F (190°C). Line baking sheets with parchment paper.",
              "In a large bowl, cream together butter and both sugars until light and fluffy.",
              "Beat in eggs one at a time, then stir in vanilla.",
              "In a separate bowl, combine flour, baking soda, and salt.",
              "Gradually blend the dry ingredients into the wet mixture.",
              "Fold in chocolate chips.",
              "Drop by rounded tablespoons onto the prepared baking sheets, about 2 inches apart.",
              "Bake for 9-11 minutes or until golden brown around the edges.",
              "Allow cookies to cool on the baking sheet for 5 minutes before transferring to a wire rack."
            ],
            featured: true,
            popular: false
          },
          {
            id: 5,
            title: "Food Concepts",
            description: "A refreshing and healthy traditional Greek salad with feta cheese and olives.",
            image: "/images/gallery/FoodConcepts/1.JPG",
            category: "food",
            prepTime: 15,
            cookTime: 0,
            servings: 4,
            difficulty: "Easy",
            ingredients: [
              "3 large tomatoes, cut into chunks",
              "1 cucumber, sliced",
              "1 red onion, thinly sliced",
              "1 green bell pepper, chopped",
              "1 cup Kalamata olives",
              "7 oz feta cheese, cubed",
              "2 tsp dried oregano",
              "1/4 cup extra virgin olive oil",
              "2 tbsp red wine vinegar",
              "Salt and pepper to taste"
            ],
            instructions: [
              "In a large bowl, combine tomatoes, cucumber, red onion, bell pepper, and olives.",
              "Gently fold in the feta cheese cubes.",
              "In a small bowl, whisk together olive oil, red wine vinegar, dried oregano, salt, and pepper.",
              "Pour the dressing over the salad and toss gently to combine.",
              "Let the salad sit for 10 minutes before serving to allow flavors to blend."
            ],
            featured: true,
            popular: true
          },
          {
            id: 6,
            title: "Authumn Menu",
            description: "Delicious homemade pizza with your favorite toppings.",
            image: "/images/403.png",
            category: "pizza",
            prepTime: 30,
            cookTime: 15,
            servings: 4,
            difficulty: "Medium",
            ingredients: [
              "For the dough:",
              "2 1/4 tsp active dry yeast",
              "1 tsp sugar",
              "1 cup warm water",
              "2 1/2 cups all-purpose flour",
              "2 tbsp olive oil",
              "1 tsp salt",
              "For the toppings:",
              "1/2 cup pizza sauce",
              "2 cups shredded mozzarella cheese",
              "1 cup sliced pepperoni",
              "1/2 cup sliced bell peppers",
              "1/4 cup sliced red onions",
              "1/4 cup sliced black olives",
              "1 tsp dried oregano"
            ],
            instructions: [
              "In a small bowl, dissolve yeast and sugar in warm water. Let stand for 5-10 minutes until foamy.",
              "In a large bowl, combine flour and salt. Add the yeast mixture and olive oil.",
              "Knead the dough on a floured surface until smooth and elastic, about 5-7 minutes.",
              "Place dough in an oiled bowl, cover, and let rise in a warm place for 1 hour or until doubled in size.",
              "Preheat oven to 450°F (230°C).",
              "Punch down dough and roll out on a floured surface to form a 12-inch circle.",
              "Transfer to a pizza pan or baking sheet.",
              "Spread pizza sauce over the dough, leaving a 1/2-inch border for the crust.",
              "Sprinkle with mozzarella cheese and arrange desired toppings.",
              "Bake for 12-15 minutes until crust is golden and cheese is bubbly.",
              "Sprinkle with dried oregano before serving."
            ],
            featured: true,
            popular: true
          }
        ],
      featured: true,
      popular: true
    },
    {
      id: 6,
      title: "Autumn Menu",
      description: "Delicious homemade pizza with your favorite toppings.",
      image: "/images/gallery/Autumn/1.JPG",
      category: "autumn",
      prepTime: 30,
      cookTime: 15,
      servings: 4,
      difficulty: "Medium",
      ingredients: [
        "For the dough:",
        "2 1/4 tsp active dry yeast",
        "1 tsp sugar",
        "1 cup warm water",
        "2 1/2 cups all-purpose flour",
        "2 tbsp olive oil",
        "1 tsp salt",
        "For the toppings:",
        "1/2 cup pizza sauce",
        "2 cups shredded mozzarella cheese",
        "1 cup sliced pepperoni",
        "1/2 cup sliced bell peppers",
        "1/4 cup sliced red onions",
        "1/4 cup sliced black olives",
        "1 tsp dried oregano"
      ],
      instructions: [
        "In a small bowl, dissolve yeast and sugar in warm water. Let stand for 5-10 minutes until foamy.",
        "In a large bowl, combine flour and salt. Add the yeast mixture and olive oil.",
        "Knead the dough on a floured surface until smooth and elastic, about 5-7 minutes.",
        "Place dough in an oiled bowl, cover, and let rise in a warm place for 1 hour or until doubled in size.",
        "Preheat oven to 450°F (230°C).",
        "Punch down dough and roll out on a floured surface to form a 12-inch circle.",
        "Transfer to a pizza pan or baking sheet.",
        "Spread pizza sauce over the dough, leaving a 1/2-inch border for the crust.",
        "Sprinkle with mozzarella cheese and arrange desired toppings.",
        "Bake for 12-15 minutes until crust is golden and cheese is bubbly.",
        "Sprinkle with dried oregano before serving."
      ],
      featured: true,
      popular: true
    }
  ];
  
  export const categories = [
    {
      id: 1,
      name: "Pasta",
      slug: "pasta",
      image: "/images/404.png",
      description: "Delicious pasta recipes from Italy and beyond."
    },
    {
      id: 2,
      name: "Vegetarian",
      slug: "vegetarian",
      image: "/images/405.png",
      description: "Healthy and tasty vegetarian meals."
    },
    {
      id: 3,
      name: "Desserts",
      slug: "desserts",
      image: "/images/402.png",
      description: "Sweet treats for any occasion."
    },
    {
      id: 4,
      name: "Salads",
      slug: "salads",
      image: "/images/406.png",
      description: "Fresh and nutritious salad recipes."
    },
    {
      id: 5,
      name: "Pizza",
      slug: "pizza",
      image: "/images/403.png",
      description: "Homemade pizza recipes with various toppings."
    },
    {
      id: 6,
      name: "Burgers",
      slug: "burgers",
      image: "/images/401.png",
      description: "Classic and gourmet burger recipes."
    }
  ];